<template>
  <div class="team-score">
    <ve-histogram width="1134px" :data="scoreData"></ve-histogram>
  </div>
</template>

<script>
import { teamItemScore } from "@/api/projectPractice/analysis";

export default {
  data() {
    return {
      scoreData: {
        columns: [],
        rows: [],
      },
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      teamItemScore({ classId: this.$route.query.id }).then((res) => {
        if (res.code == 0) {
          let columns = ["category"];
          let list = [];
          res.data.forEach((item) => {
            columns.push(item.teamName);
            item.list.forEach((n) => {
              list.push({ teamName: item.teamName, ...n });
            });
          });

          const labelMap = {
            dw: "账号定位",
            dj: "账号搭建",
            wa: "文案创作",
            jb: "脚本创作",
            ps: "视频拍摄",
            jj: "视频剪辑",
            yy: "账号运营",
            ly: "成果路演",
          };

          let rows = [];
          for (let prop in labelMap) {
            let teamObj = {};
            list
              .filter((item) => item.category == prop)
              .forEach((item) => {
                teamObj.category = labelMap[item.category];
                teamObj[item.teamName] = item.score;
              });
            if (Object.keys(teamObj).length != 0) rows = rows.concat(teamObj);
          }
          this.scoreData.columns = columns;
          this.scoreData.rows = rows;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.team-score {
  text-align: left;
}
</style>